import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Shadow, Units, Colors } from 'Css';
import Portal from 'components/Portal';

const css = oxygenCss({
  bubble: {
    zIndex: 1000,
    position: 'absolute',
    // boxShadow: Shadow[1],
    backgroundColor: Colors.theme.Light.card,
    color: Colors.text.Dark.default,
    // fontSize: 12,
    borderRadius: Units.base / 2,
    display: 'inline-block',
    boxSizing: 'border-box',
    border: `${Colors.material.grey[300].hex} solid 2px`,
    opacity: 0,
    '&padded': {
      padding: Units.base / 2
    },
    '&active': {
      transition: 'opacity 0.25s ease',
      opacity: 1
    },
    '&hasArrow': {
      ':after': {
        bottom: '100%',
        left: '50%',
        border: 'solid transparent',
        content: ' ',
        height: 0,
        width: 0,
        position: 'absolute',
        pointerEvents: 'none',

        borderColor: 'transparent',
        borderBottomColor: Colors.theme.Light.card,
        borderWidth: Units.base,
        marginLeft: `${-Units.base}px`
        // content: ' ',
        // width: 0,
        // height: 0,
        // position: 'absolute',
        // borderStyle: 'solid',
        // borderWidth: `0 ${Units.base}px ${Units.base}px`,
        // borderColor: `${Colors.theme.Light.card} transparent`,
        // display: 'block',
        // width: 0,
        // zIndex: 1,
        // top: `${-Units.base}px`,
        // marginLeft: `${-Units.base}px`,
        // left: '50%',
      },
      ':before': {
        bottom: '100%',
        left: '50%',
        border: 'solid transparent',
        content: ' ',
        height: 0,
        width: 0,
        position: 'absolute',
        pointerEvents: 'none',

        borderColor: 'transparent',
        borderBottomColor: Colors.material.grey[300].hex,
        borderWidth: `${Units.base + 3}px`,
        marginLeft: `${-Units.base - 3}px`

        // content: '',
        // position: 'absolute',
        // borderStyle: 'solid',
        // borderWidth: `0 ${Units.base + 4}px ${Units.base + 4}px`,
        // borderColor: `${Colors.text.Light.divider}`,
        // display: 'block',
        // width: 0,
        // zIndex: 0,
        // top: `${-Units.base }px`,
        // marginLeft: `${-Units.base - 2}px`,
        // left: '50%',
      }
    }
  }
});

class Tooltip extends Component {
  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    anchorTo: PropTypes.func,
    padded: PropTypes.bool,
    getPosition: PropTypes.func,
    hasArrow: PropTypes.bool
  };

  static defaultProps = {
    padded: true,
    hasArrow: true
  };

  state = {
    top: null,
    left: null,
    width: null
  };

  componentDidUpdate() {
    this.position();
  }

  getTooltipStyle() {
    const { width, top, left } = this.state;
    return {
      transform: `translate3d( ${left || 0}px, ${top || 0}px, 0px)`,
      width
    };
  }

  getPosition() {
    const { getPosition } = this.props;
    const rect = this._anchor.getBoundingClientRect();
    const ownRect = this._portal.getBoundingClientRect();
    if (getPosition) {
      return getPosition(rect, ownRect);
    }
    return this.defaultPosition(rect, ownRect);
  }

  defaultPosition(rect, ownRect) {
    return {
      left: rect.left - ownRect.width / 2 + rect.width / 2,
      top: rect.top + rect.height + Units.base * 2
    };
  }

  handleMount = portal => {
    const { anchorTo } = this.props;
    this._anchor = anchorTo();
    this._portal = portal;
    this.position();
  };

  position() {
    const { left, top, width } = this.getPosition();
    if (this.state.left !== left || this.state.top !== top) {
      this.setState({
        left,
        top,
        width
      });
    }
  }

  render() {
    const { children, style, padded, hasArrow, ...other } = this.props;
    const { top } = this.state;
    return (
      <Portal
        onMount={this.handleMount}
        className={classNames(css.bubble, {
          [css.hasArrow]: hasArrow,
          [css.padded]: padded,
          [css.active]: top !== null
        })}
        style={this.getTooltipStyle()}
        {...other}
      >
        {children}
      </Portal>
    );
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/js/components/Tooltip.js